// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-main {
  max-width: 48rem;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
}

.game-back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 2rem;
  color: var(--landing-muted);
  font-size: 0.9375rem;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
}

.game-back-link:hover {
  color: var(--landing-cyan);
}

.game-header {
  margin-bottom: 2rem;
}

.game-eyebrow {
  display: inline-block;
  margin-bottom: 0.75rem;
  padding: 0.375rem 0.875rem;
  border-radius: 9999px;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface);
  color: var(--landing-cyan);
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.game-title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 0.5rem;
}

.game-subtitle {
  margin: 0;
  color: var(--landing-muted);
  font-size: 1rem;
  line-height: 1.6;
}

.game-card {
  background: var(--landing-surface);
  border: 1px solid var(--landing-border);
  border-radius: 1.25rem;
  padding: 1.75rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
}

.game-settings {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem 1.25rem;
  border-radius: 0.75rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface-alt);
}

.game-settings label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--landing-muted);
  white-space: nowrap;
}

.game-settings input {
  width: 4.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-bg);
  color: var(--landing-text);
  font-size: 1rem;
  font-family: inherit;
}

.game-settings input:focus {
  outline: none;
  border-color: var(--landing-cyan);
}

.game-category-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 640px) {
  .game-category-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.game-category-btn,
.game-level-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
  width: 100%;
  padding: 1.25rem;
  border-radius: 1rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface-alt);
  color: var(--landing-text);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s, background 0.2s;
}

.game-category-btn:hover,
.game-level-btn:hover {
  border-color: rgba(245, 185, 66, 0.4);
  background: rgba(245, 185, 66, 0.06);
  transform: translateY(-2px);
}

.game-category-btn h2,
.game-level-btn h2 {
  font-family: "Outfit", sans-serif;
  font-size: 1.0625rem;
  font-weight: 600;
  margin: 0;
}

.game-category-btn p,
.game-level-btn p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--landing-muted);
  line-height: 1.5;
}

.game-level-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.game-play-card {
  max-width: 36rem;
  margin: 0 auto;
}

.game-play-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.game-play-header h1 {
  font-family: "Outfit", sans-serif;
  font-size: 1.375rem;
  font-weight: 700;
  margin: 0 0 0.375rem;
}

.game-play-meta {
  font-size: 0.8125rem;
  color: var(--landing-muted);
  margin: 0;
}

.game-timer {
  width: 5rem;
  height: 5rem;
  margin: 0 auto 1.25rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 3px solid var(--landing-cyan);
  background: rgba(61, 214, 200, 0.1);
  font-family: "Outfit", sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: var(--landing-cyan);
  transition: border-color 0.3s, color 0.3s;
}

.game-timer--urgent {
  border-color: var(--landing-error);
  background: rgba(248, 113, 113, 0.1);
  color: var(--landing-error);
}

.game-progress {
  height: 4px;
  border-radius: 9999px;
  background: var(--landing-surface-alt);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.game-progress-bar {
  height: 100%;
  border-radius: 9999px;
  background: linear-gradient(90deg, var(--landing-purple), var(--landing-cyan));
  transition: width 1s linear;
}

.game-question {
  text-align: center;
  font-size: 1.0625rem;
  font-weight: 500;
  line-height: 1.55;
  margin: 0 0 1.25rem;
}

.game-answers {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.game-answer {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-radius: 0.625rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface-alt);
  color: var(--landing-text);
  font-size: 0.9375rem;
  line-height: 1.45;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  text-align: left;
}

.game-answer:hover:not(.game-answer--locked) {
  border-color: rgba(61, 214, 200, 0.4);
  background: rgba(61, 214, 200, 0.06);
}

.game-answer--selected-correct {
  border-color: rgba(52, 211, 153, 0.6);
  background: rgba(52, 211, 153, 0.12);
  color: var(--landing-success);
}

.game-answer--selected-wrong {
  border-color: rgba(248, 113, 113, 0.6);
  background: rgba(248, 113, 113, 0.12);
  color: var(--landing-error);
}

.game-answer--locked {
  cursor: default;
}

.game-answer-letter {
  flex-shrink: 0;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--landing-accent);
}

.game-comment {
  margin-top: 1.25rem;
  padding: 1rem 1.125rem;
  border-radius: 0.75rem;
  border-left: 3px solid var(--landing-accent);
  background: rgba(245, 185, 66, 0.08);
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--landing-text);
}

.game-actions {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}

.game-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  border-radius: 0.75rem;
  border: none;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
}

.game-btn--primary {
  background: linear-gradient(135deg, var(--landing-accent), #e8940a);
  color: var(--landing-bg);
  box-shadow: 0 4px 24px rgba(245, 185, 66, 0.3);
}

.game-btn--primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(245, 185, 66, 0.4);
}

.game-btn--secondary {
  background: var(--landing-surface-alt);
  border: 1px solid var(--landing-border);
  color: var(--landing-text);
}

.game-btn--secondary:hover {
  border-color: rgba(61, 214, 200, 0.4);
  color: var(--landing-cyan);
}

.game-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.game-text-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
  padding: 0;
  border: none;
  background: none;
  color: var(--landing-cyan);
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
}

.game-text-link:hover {
  color: var(--landing-accent);
}

.game-empty {
  text-align: center;
  padding: 2rem;
  color: var(--landing-muted);
}
`, "",{"version":3,"sources":["webpack://./src/assets/game.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,uCAAuC;EACvC,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;;EAEE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;EAC5C,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,mEAAmE;EACnE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B","sourcesContent":[".game-main {\n  max-width: 48rem;\n  margin: 0 auto;\n  padding: 2.5rem 1.5rem 4rem;\n}\n\n.game-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  margin-bottom: 2rem;\n  color: var(--landing-muted);\n  font-size: 0.9375rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.game-back-link:hover {\n  color: var(--landing-cyan);\n}\n\n.game-header {\n  margin-bottom: 2rem;\n}\n\n.game-eyebrow {\n  display: inline-block;\n  margin-bottom: 0.75rem;\n  padding: 0.375rem 0.875rem;\n  border-radius: 9999px;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface);\n  color: var(--landing-cyan);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.game-title {\n  font-family: \"Outfit\", sans-serif;\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0 0 0.5rem;\n}\n\n.game-subtitle {\n  margin: 0;\n  color: var(--landing-muted);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.game-card {\n  background: var(--landing-surface);\n  border: 1px solid var(--landing-border);\n  border-radius: 1.25rem;\n  padding: 1.75rem;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n}\n\n.game-settings {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem 1.25rem;\n  border-radius: 0.75rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface-alt);\n}\n\n.game-settings label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--landing-muted);\n  white-space: nowrap;\n}\n\n.game-settings input {\n  width: 4.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-bg);\n  color: var(--landing-text);\n  font-size: 1rem;\n  font-family: inherit;\n}\n\n.game-settings input:focus {\n  outline: none;\n  border-color: var(--landing-cyan);\n}\n\n.game-category-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n@media (min-width: 640px) {\n  .game-category-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.game-category-btn,\n.game-level-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.375rem;\n  width: 100%;\n  padding: 1.25rem;\n  border-radius: 1rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface-alt);\n  color: var(--landing-text);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.2s, transform 0.2s, background 0.2s;\n}\n\n.game-category-btn:hover,\n.game-level-btn:hover {\n  border-color: rgba(245, 185, 66, 0.4);\n  background: rgba(245, 185, 66, 0.06);\n  transform: translateY(-2px);\n}\n\n.game-category-btn h2,\n.game-level-btn h2 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.0625rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.game-category-btn p,\n.game-level-btn p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--landing-muted);\n  line-height: 1.5;\n}\n\n.game-level-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.game-play-card {\n  max-width: 36rem;\n  margin: 0 auto;\n}\n\n.game-play-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.game-play-header h1 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.375rem;\n  font-weight: 700;\n  margin: 0 0 0.375rem;\n}\n\n.game-play-meta {\n  font-size: 0.8125rem;\n  color: var(--landing-muted);\n  margin: 0;\n}\n\n.game-timer {\n  width: 5rem;\n  height: 5rem;\n  margin: 0 auto 1.25rem;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 3px solid var(--landing-cyan);\n  background: rgba(61, 214, 200, 0.1);\n  font-family: \"Outfit\", sans-serif;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--landing-cyan);\n  transition: border-color 0.3s, color 0.3s;\n}\n\n.game-timer--urgent {\n  border-color: var(--landing-error);\n  background: rgba(248, 113, 113, 0.1);\n  color: var(--landing-error);\n}\n\n.game-progress {\n  height: 4px;\n  border-radius: 9999px;\n  background: var(--landing-surface-alt);\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n}\n\n.game-progress-bar {\n  height: 100%;\n  border-radius: 9999px;\n  background: linear-gradient(90deg, var(--landing-purple), var(--landing-cyan));\n  transition: width 1s linear;\n}\n\n.game-question {\n  text-align: center;\n  font-size: 1.0625rem;\n  font-weight: 500;\n  line-height: 1.55;\n  margin: 0 0 1.25rem;\n}\n\n.game-answers {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n}\n\n.game-answer {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.875rem 1rem;\n  border-radius: 0.625rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface-alt);\n  color: var(--landing-text);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  text-align: left;\n}\n\n.game-answer:hover:not(.game-answer--locked) {\n  border-color: rgba(61, 214, 200, 0.4);\n  background: rgba(61, 214, 200, 0.06);\n}\n\n.game-answer--selected-correct {\n  border-color: rgba(52, 211, 153, 0.6);\n  background: rgba(52, 211, 153, 0.12);\n  color: var(--landing-success);\n}\n\n.game-answer--selected-wrong {\n  border-color: rgba(248, 113, 113, 0.6);\n  background: rgba(248, 113, 113, 0.12);\n  color: var(--landing-error);\n}\n\n.game-answer--locked {\n  cursor: default;\n}\n\n.game-answer-letter {\n  flex-shrink: 0;\n  font-family: \"Outfit\", sans-serif;\n  font-weight: 700;\n  color: var(--landing-accent);\n}\n\n.game-comment {\n  margin-top: 1.25rem;\n  padding: 1rem 1.125rem;\n  border-radius: 0.75rem;\n  border-left: 3px solid var(--landing-accent);\n  background: rgba(245, 185, 66, 0.08);\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--landing-text);\n}\n\n.game-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n\n.game-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.75rem;\n  border-radius: 0.75rem;\n  border: none;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;\n}\n\n.game-btn--primary {\n  background: linear-gradient(135deg, var(--landing-accent), #e8940a);\n  color: var(--landing-bg);\n  box-shadow: 0 4px 24px rgba(245, 185, 66, 0.3);\n}\n\n.game-btn--primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 32px rgba(245, 185, 66, 0.4);\n}\n\n.game-btn--secondary {\n  background: var(--landing-surface-alt);\n  border: 1px solid var(--landing-border);\n  color: var(--landing-text);\n}\n\n.game-btn--secondary:hover {\n  border-color: rgba(61, 214, 200, 0.4);\n  color: var(--landing-cyan);\n}\n\n.game-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.game-text-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-bottom: 1.25rem;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--landing-cyan);\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.game-text-link:hover {\n  color: var(--landing-accent);\n}\n\n.game-empty {\n  text-align: center;\n  padding: 2rem;\n  color: var(--landing-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
